import { Dispatch, SetStateAction } from "react";
import { IDebugLogger } from "../../../utils/debugLogger";

const getLogout = ({
	setFbAccessToken,
	setProfileImage,
	setUserId,
	debug
}: {
	setFbAccessToken: Dispatch<SetStateAction<string | null>>;
	setProfileImage: Dispatch<SetStateAction<string | null>>;
	setUserId: Dispatch<SetStateAction<string>>;
	debug: IDebugLogger;
}) => {
	const logout = async () => {
		debug.logFunction({
			iconText: "/FacebookProvider/api/logout:",
			message: [
				"\nsetLogoutState:",
				"[fbAccessToken, fbProfileImage, fbUserId]",
				null,
				null,
				""
			]
		});

		!!window.FB &&
			window.FB.getLoginStatus((response: fb.StatusResponse) => {
				if (response.status === "connected") {
					(window.FB as fb.FacebookStatic)?.logout(
						(response: fb.StatusResponse) => {
							debug.log({
								iconText: "logout -> FB.logout:",
								message: ["\nresponse:", response]
							});
						}
					);
				}
			});

		if (setFbAccessToken) {
			setFbAccessToken(null);
		}
		localStorage.removeItem("store.solitairetripeaks.com:fbAccessToken");
		setProfileImage(null);
		setUserId("");
	};
	return logout;
};

export default getLogout;
